export default "__VITE_PUBLIC_ASSET__a3f82cec__"